import { render, staticRenderFns } from "./PageLogiciels.vue?vue&type=template&id=8975f746&scoped=true"
import script from "./PageLogiciels.vue?vue&type=script&lang=js"
export * from "./PageLogiciels.vue?vue&type=script&lang=js"
import style0 from "./PageLogiciels.vue?vue&type=style&index=0&id=8975f746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8975f746",
  null
  
)

export default component.exports